export default "__VITE_ASSET__BgglVtxC__"